import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(provenanceId: number) {
    const requestBody = {
      deleted: '1',
      id: provenanceId,
    }
    const response = await api.fetch(
      `/api/v2/provenances/update/id/${provenanceId}`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    return await handleResponse(response)
  }
}
